<template>
  <div class="pc-controls">
    <button class="pc-btn pc-btn-play" @click="$emit('play')" :disabled="isPlaying">
      {{ isPlaying ? '▶' : '▶' }}
    </button>
    <button class="pc-btn pc-btn-pause" @click="$emit('pause')" :disabled="!isPlaying">
      ⏸
    </button>
    <button class="pc-btn pc-btn-stop" @click="$emit('stop')">
      ⏹
    </button>
    <button class="pc-btn pc-btn-prev" @click="$emit('prev')">
      ◀
    </button>
    <button class="pc-btn pc-btn-next" @click="$emit('next')">
      ▶
    </button>
    <div class="pc-seek" @click="handleSeek">
      <div class="pc-seek-fill" :style="{ width: progressPercent + '%' }"></div>
    </div>
    <div class="pc-text">{{ currentIndex + 1 }} / {{ totalBars }}</div>
  </div>
</template>

<script>
export default {
  name: 'PlayerControls',
  props: {
    currentIndex: {
      type: Number,
      default: 0
    },
    totalBars: {
      type: Number,
      default: 0
    },
    isPlaying: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    progressPercent() {
      if (this.totalBars === 0) return 0
      return ((this.currentIndex + 1) / this.totalBars) * 100
    }
  },
  methods: {
    handleSeek(event) {
      const rect = event.currentTarget.getBoundingClientRect()
      const percent = (event.clientX - rect.left) / rect.width
      const index = Math.floor(percent * this.totalBars)
      this.$emit('seek', Math.max(0, Math.min(this.totalBars - 1, index)))
    }
  }
}
</script>

<style scoped>
.pc-controls {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  background: #1e222d;
  border-top: 1px solid #2a2e39;
  height: 100%;
}

.pc-btn {
  background: transparent;
  border: 1px solid #2a2e39;
  color: #d1d4dc;
  width: 24px;
  height: 24px;
  border-radius: 3px;
  cursor: pointer;
  font-size: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  transition: all 0.15s;
  flex-shrink: 0;
}

.pc-btn:hover:not(:disabled) {
  background: #2a2e39;
  border-color: #363a45;
}

.pc-btn:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.pc-btn-play:hover:not(:disabled) {
  background: rgba(8, 153, 129, 0.12);
  border-color: rgba(8, 153, 129, 0.3);
  color: #089981;
}

.pc-btn-pause:hover:not(:disabled) {
  background: rgba(242, 149, 0, 0.12);
  border-color: rgba(242, 149, 0, 0.3);
  color: #f29500;
}

.pc-btn-stop:hover:not(:disabled) {
  background: rgba(242, 54, 69, 0.12);
  border-color: rgba(242, 54, 69, 0.3);
  color: #f23645;
}

.pc-seek {
  flex: 1;
  height: 4px;
  background: #131722;
  border-radius: 2px;
  cursor: pointer;
  position: relative;
  min-width: 80px;
  margin: 0 4px;
}

.pc-seek-fill {
  height: 100%;
  background: #2962ff;
  border-radius: 2px;
  transition: width 0.1s;
}

.pc-text {
  font-size: 10px;
  color: #787b86;
  min-width: 70px;
  text-align: right;
  font-weight: 500;
}
</style>
